<div *ngIf="ipoList?.length>0" id="dark" class="ipo-bg page-alignment">
    <div  class="row mx-2">

        <div class="col-sm-12 col-md-12 col-lg-4 col-xlg-4">
            <div class=" p-4 container-bg radius-20" >
                <div class="d-flex flex-wrap justify-content-center  mb-3 gradient-container radius-20 gradient-card-padding">
                    <div class="row vw-100 justify-content-between">
                        <div class="col-10">
                            <div class="d-flex align-items-center">
                                <h3 class="text-light font-xlarge font-600">{{ "ipoTitle" | translate }}</h3>
                                <!-- <span>
                                    <hint-popover [key]="'gross-sales-hint'" [iconColor] ="'#f8f9fa'"></hint-popover>
                                </span> -->
                            </div>
                            <div class="row text-justify">
                                <span class="text-light font-small">{{ "ipoDesc" | translate }}
                                </span>
                            </div>
                        </div>
                        <div class="col-2 px-0">
                            <img class="gradient-card-icon-width" src="assets/img/Frame.png" alt="">
                        </div>
                    </div>

                    <!-- TODO: Will be uncommented soon (Pending) -->
                    <!-- <div class="row justify-content-sm-center my-3 btn-gap">
                        <button class="p-3 gradient-card-btns teal-btn col-5 col-offset-2 font-small">
                            <span>
                                <hint-popover [key]="'gross-sales-hint'" [iconColor]="'#FFFFFF'"></hint-popover>
                            </span>
                            <span>
                                {{'learnmore'|translate}}
                            </span>
                        </button>
                        <button class="p-3 gradient-card-btns yellow-btn  col-5 col-offset-2 font-small">
                            <span>
                                <img src="assets/img/Layers.png" alt="">
                            </span>
                            <span>
                                {{'myOrders'|translate}}
                            </span>
                        </button>
                    </div> -->

                </div>

                <div>
                    <div 
                    *ngFor="let ipo of ipoList let i = index" 
                    [class.IPO-selected-card-item]="ipo.selected"
                    [class.IPO-unselected-card]="!ipo.selected"
                    class="IPO-card my-4" (click)="selectIPO(ipo, i)">
                        <div class="p-2 IPO-card-header leaf  font-small" [style.left]="translate.currentLang=='ar' ? '0':null"
                            [style.right]="translate.currentLang=='en' ? '0':null">
                            {{lang == 'ar'? ipo?.IpoStatusAr : ipo?.IpoStatusEn}}
                        </div>
                        <div class="row mx-1">
                            <div class="IPO-card-logo-container d-flex align-item-center">
                                <img class="avatar " [src]="ipo.Logo" alt="">
                            </div>
                            <div class="mx-3 d-flex flex-column align-items-start">
                                <h5 class="text-color-theme font-medium font-600">{{lang == 'ar'? ipo?.NameAr : ipo?.NameEn}}</h5>
                                <h6 *ngIf="ipo?.SectorEn && lang == 'en'" class="dimmed-Title font-small">{{ipo?.SectorEn}}</h6>
                                <h6 *ngIf="ipo?.SectorAr && lang == 'ar'" class="dimmed-Title font-small">{{ipo?.SectorAr}}</h6>
                            </div>
                        </div>
                        <div class="d-flex flex-wrap flex-sm-column flex-lg-row my-3">
                            <div *ngIf="ipo?.StockPrice || ipo?.MinPrice" class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xm-12  d-flex flex-column align-items-start">
                                <div class="text-nowrap dimmed-title-2 font-small">
                                    <ng-container *ngIf="ipo?.PriceType === 0; else rangePrice">
                                        {{ "ipoPrice" | translate }}
                                    </ng-container>
                                    <ng-template #rangePrice>
                                        {{ "range-price" | translate }}
                                    </ng-template>
                                    <span>
                                        <hint-popover [key]="'ipo-price-hint'" [iconColor]="isDarkTheme ? '#dedede' : 'lightslategray'">
                                        </hint-popover>
                                    </span>
                                </div>
                                <span class="text-highlight-company-color font-medium font-600">
                                    <ng-container *ngIf="ipo?.PriceType === 0">
                                        {{
                                            ipo?.StockPrice != null
                                                ? (ipo?.StockPrice | number: '1.2-2')
                                                : (ipo?.MinPrice | number: '1.2-2')
                                        }}
                                    </ng-container>
                                    <ng-container *ngIf="ipo?.PriceType === 1">
                                        {{ ipo?.MinPrice | number: '1.2-2' }} - {{ ipo?.MaxPrice | number: '1.2-2' }}
                                    </ng-container>
                                    {{ "EGP" | translate }}
                                </span>
                            </div>
                            <div *ngIf="ipo?.TypeAr || ipo?.TypeEn" class="col-12 col-lg-6 col-md-6 w-100 d-flex flex-column align-items-start">
                                <div class="dimmed-title-2 font-small">
                                    {{ "ipoType" | translate }}
                                    <span>
                                        <hint-popover [key]="'ipo-type-hint'"
                                            [iconColor]="isDarkTheme?'#dedede':'lightslategray'"></hint-popover>
                                    </span>
                                </div>
                                <span class="text-highlight-company-color font-medium font-600">{{lang == 'ar'? ipo?.TypeAr : ipo?.TypeEn}}</span>
                            </div>
                        </div>
                        <div class="horizonatl-line"></div>
                        <div class="d-flex flex-wrap my-3">
                            <div class="col-8 d-flex flex-column align-items-start">
                                <h4 class="text-nowrap" >
                                    <span class="text-color-theme font-medium">
                                        {{ "iPOAllocationRatio" | translate }}
                                    </span>
                                    <span>
                                        <hint-popover [key]="'ipo-allotment-ratio-hint2'"
                                            [iconColor]="isDarkTheme?'#dedede':'lightslategray'"></hint-popover>
                                    </span>
                                </h4>
                                <span class="dimmed-title-2 font-small  text-start"
                                    [dir]="translate.currentLang == 'en' ? 'ltr' : 'rtl'">
                                    {{ "iPOAllocationRatioDesc" | translate }}
                                </span>
                            </div>
                            <div class="col-4 text-highlight-company-color font-medium font-600" *ngIf="ipo.IPOTotalVolume!=0">
                                {{ ipo.ipoAllotmentRatio | numberFormat }}%
                                <span><button
                                    type="button"
                                    class="btn btn-default btn-circle shadow-none"
                                    (click)="refreshCLicked()"
                                  >
                                    <i class="fas fa-refresh text-color-themeNotImportant" *ngIf="!isRefreshing"></i>
                                    <span
                                      
                                      class="spinner-border spinner-border-sm" *ngIf="isRefreshing"
                                    ></span>
                                  </button></span>
                            </div>
                        </div>
                        <div class="horizonatl-line"></div>
                        <ng-container *ngIf="ipo?.StartDate">
                            <div  class="d-flex justify-content-between my-3 ">
                                <div class="d-flex ">
                                    <div class="green-calender-icon-container calender-icon-container p-2 d-flex">
                                        <img src="assets/img/Calendarg.svg" alt="">
                                    </div>
                                    <div class="mx-2 d-flex flex-column align-items-start">
                                        <span class="dimmed-title-2 font-small">{{ "startDate" | translate }}</span>
                                        <span class="text-color-theme font-medium font-600">{{ipo?.StartDate |  date: 'dd-MM-yyyy'}}</span>
                                    </div>
                                </div>
                                <div *ngIf="ipo?.EndDate" class="vertical-line  verticall-line-margin d-sm-none d-md-none d-lg-block d-xlg-block d-none"></div>
                                <div *ngIf="ipo?.EndDate" class="d-flex ">
                                    <div class="red-calender-icon-container calender-icon-container p-2 d-flex">
                                        <img src="assets/img/Calendar.svg" alt="">
                                    </div>
                                    <div class="mx-2 d-flex flex-column align-items-start">
                                        <span class="dimmed-title-2 font-small">{{ "endDate" | translate }}</span>
                                        <span class="text-color-theme font-medium font-600">{{ipo?.EndDate |  date: 'dd-MM-yyyy'}}</span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="selectedIPO" class=" col-sm-12 col-md-12 col-lg-4 col-xlg-4 my-md-4 my-sm-4 my-xs-4  my-lg-0 my-xl-0 my-4">
            <app-ipo-selected-symbol [id]="selectedIPO.Id" [ipoDocuments]="ipoDocuments" [coverageNumber]="selectedIPO.coverageRatio" [refreshEvent]="isRefreshing"></app-ipo-selected-symbol>
        </div>
        <div *ngIf="selectedIPO" class="col-sm-12 col-md-12 col-lg-4 col-xlg-4">
            <app-ipo-selected-symbol-timline-pdf [id]="selectedIPO.Id" [ipoDocuments]="ipoDocuments" ></app-ipo-selected-symbol-timline-pdf>
        </div>
    </div>
</div>
<div
    *ngIf="ipoList?.length==0"
    class="vh-100 nodata d-flex flex-column align-items-center justify-content-center"
>
    <img class="img-container" src="/assets/img/no-data-vector.png" />
    <div class="no-data-available mt-2 font-600" > {{'No-IPO-available'|translate}} </div>
</div>